import { Component } from '@angular/core';
// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import * as firebase from 'firebase/app';
import { environment } from 'src/environments/environment';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { TranslatorService } from './translator.service';
import { LoginService } from './login.service';
import { getAuth, isSignInWithEmailLink, onAuthStateChanged, signInWithEmailLink } from 'firebase/auth';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public lang = 'Română';
  public currentLang = 0;
  public customPath = '';
  private firstRun = true;
  constructor(private platform: Platform, private route: ActivatedRoute, private loginService: LoginService,
    private translator: TranslatorService, public navCtrl: NavController
  ) {
    this.loginService.setAppRef(this);
    this.selectLanguage(this.currentLang, true);
  }
  initializeApp() {
    this.platform.ready().then(() => {
      firebase.initializeApp(environment);
      const currentPath = window.location.href;
      if(currentPath.indexOf('customparam') !== -1)
      {
        this.loginService.customPath = currentPath;
      }
      const auth = getAuth();
      if (isSignInWithEmailLink(auth, window.location.href)) {
        const email = window.localStorage.getItem('emailForSignIn');
        if (!email) {
          this.loginService.showUserAuthPopup(window.location.href);
          //this.navCtrl.navigateForward('tabs/tab4');
          return;
        }
        signInWithEmailLink(auth, email, window.location.href)
          .then((result) => {
            window.localStorage.removeItem('emailForSignIn');
          })
          .catch((error) => {
            this.loginService.showUserAuthPopup(window.location.href);
            //this.navCtrl.navigateForward('tabs/tab4');
          });
      }
      onAuthStateChanged(auth, (user) => {
       // alert("<SA>");
        if (user) {
          this.loginService.activeUser = user;
          this.loginService.userAuthenticated();
        } else {
          if(this.loginService.customPath.length > 0)
          {
              this.loginService.parseCustomPath();
          }
          else{
            this.navCtrl.navigateForward('tabs/tab4');
          }
          return;
        }
      });
      
    });
  }
  public selectLanguage(id, isFirstRun = false) {
    let code = '';
    switch (id) {
      case 0:
        this.lang = 'Română';
        code = 'ro';
        break;
      case 1:
        this.lang = 'Magyar';
        code = 'hu';
        break;
      case 2:
        this.lang = 'English';
        code = 'uk';
        break;
      case 3:
        this.lang = 'عربى';
        code = 'ar';
        break;
      default:
        this.lang = 'Română';
        code = 'ro';
    }
    this.currentLang = id;
    if (code !== 'ro') {
      this.loginService.languagePath = code + '/';
    }
    else {
      this.loginService.languagePath = '';
    }
    this.translator.loadLanguage(id, code);
    if (this.firstRun === true) {
      this.firstRun = false;
      this.initializeApp();
    }
  }
}
